import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import vAanimate from './directive'
import vCopy from './directive/copy'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 自定义样式
import '@/assets/styles/base.scss'
// UnoCSS
import 'uno.css'
// Animate.css
import 'animate.css'

const app = createApp(App)
app.directive('animate', vAanimate)
app.directive('copy', vCopy)

app.use(ElementPlus)
app.use(router)
app.use(i18n)

app.mount('#app')
